import {Button} from "@mui/material";

const ButtonBlue = ({onClick, text, width = 172, disabled = false, sx}) => {
    return <Button
        onClick={onClick}
        disabled={disabled}
        sx={{
            width: width,
            height: 44,
            lineHeight: 1,
            backgroundColor: (theme) => theme.palette.primary.main,
            color: "white",
            borderRadius: "100px",
            boxShadow: "none",
            textTransform: 'none',
            whiteSpace: 'nowrap',
            '@media (max-width: 360px)': {
                width: 148,
                height: 36,
            },
            "&:hover": {
                backgroundColor: (theme) => theme.palette.primary.main,
                boxShadow: "none",
            },
            ...sx,
        }}>
        {text}
    </Button>
}
export default ButtonBlue